// Shared with the browser without pulling server cryptography into its bundle.
export const MIN_VIEW_MS = 2000;
export const MAX_VIEW_MS = 300000;
export const REPEAT_VIEW_AWAY_MS = 5000;
